/**
 * surveyI18n.js — wspólne tłumaczenia dla publicznych ankiet (dostawy + restauracja).
 *
 * Tylko statyczne teksty chrome UI są tłumaczone. Pytania z config (labels, hints, options.label)
 * pozostają w języku zdefiniowanym przez managera (najczęściej polski).
 */

const LANG_KEY = 'mrj_survey_lang';

export const LANGS = [
  { code: 'pl', flag: '🇵🇱', label: 'PL' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
];

export const getLang = () => {
  if (typeof window === 'undefined') return 'pl';
  const saved = localStorage.getItem(LANG_KEY);
  if (saved === 'pl' || saved === 'en') return saved;
  // Auto-detect
  const nav = (navigator.language || 'pl').toLowerCase();
  if (nav.startsWith('pl')) return 'pl';
  return 'en';
};

export const setLang = (code) => {
  if (typeof window !== 'undefined') localStorage.setItem(LANG_KEY, code);
};

export const STR = {
  pl: {
    brand_sub_delivery: 'Twoja opinia pomoże nam być lepszymi. Wypełnij krótką ankietę — na końcu czeka mała niespodzianka 🎁',
    brand_sub_restaurant: 'Wypełnij krótką ankietę i weź udział w losowaniu vouchera 🎁',
    hero_delivery: 'Jak nasza dostawa?',
    hero_restaurant: 'Jak Ci u nas smakowało?',
    progress: 'Postęp ankiety',
    question_label: 'PYTANIE',
    optional_badge: 'OPCJONALNE',
    required_badge: 'WYMAGANE',
    add_comment: '💬 Chcesz coś dodać? (opcjonalnie)',
    comment_placeholder: 'Twoja uwaga do tego pytania…',
    text_placeholder: 'Twoja odpowiedź…',
    text_placeholder_delivery: 'Napisz nam co byśmy poprawili… (opcjonalnie)',
    photo_required: '📸 ZDJĘCIE · WYMAGANE',
    photo_label: 'Dodaj zdjęcie tego co zamówiłeś!',
    photo_hint: 'np. koktajl miesiąca, lampka wina, deser, danie. Bez zdjęcia nie weźmiesz udziału w losowaniu — wybrane zdjęcia trafią na nasz Instagram.',
    choose_photo: 'Wybierz zdjęcie',
    contact_show_delivery: 'Zostaw kontakt (opcjonalnie)',
    contact_show_restaurant: 'Zostaw kontakt (WAŻNE — wynik podamy bezpośrednio)',
    contact_hide: 'Schowaj kontakt',
    contact_hint_delivery: 'Zadzwonimy podziękować lub naprawić problem — kontakt jest opcjonalny.',
    contact_hint_restaurant: 'Jeśli wygrasz, skontaktujemy się — bez tego nie damy rady przekazać voucher.',
    name: 'Imię',
    phone: 'Telefon',
    email: 'E-mail',
    submit_delivery: '🎁 Wyślij i odbierz niespodziankę',
    submit_restaurant: '🎁 Wyślij i weź udział w losowaniu',
    submitting: 'Wysyłanie…',
    answer_n_questions: (n) => `Odpowiedz na ${n} ${n === 1 ? 'pytanie' : 'pytania'}`,
    add_photo_to_join: '📸 Dodaj zdjęcie żeby wziąć udział',
    answer_and_add_photo: (n) => `Odpowiedz na ${n} ${n === 1 ? 'pytanie' : 'pytania'} i dodaj zdjęcie`,
    thanks: 'Dziękujemy za opinię!',
    your_code: 'Twój kod',
    copy_code: 'Skopiuj kod',
    copied: 'Skopiowano!',
    order_with_discount: 'Zamów online z rabatem',
    loading: 'Przygotowujemy ankietę…',
    ups: 'Ups…',
    footer_delivery: 'Twoja opinia trafia bezpośrednio do managera MR JERRY',
    footer_restaurant: 'Twoja opinia trafia bezpośrednio do MR JERRY',
    no_coupon_msg: 'Niestety w tej chwili zabrakło kuponów. Zadzwoń lub napisz do nas — odbierzesz nagrodę osobiście.',
    voucher_default_title: 'Voucher dla zwycięzcy',
    pool_size: (m, p) => `Bierzesz udział w losowaniu (miesiąc ${m}, w puli: ${p})`,
    good_luck_restaurant: 'Powodzenia! Skontaktujemy się ze zwycięzcą bezpośrednio. Wybrane zdjęcia trafią na',
  },
  en: {
    brand_sub_delivery: 'Your feedback helps us improve. Fill in this short survey — a little surprise awaits at the end 🎁',
    brand_sub_restaurant: 'Fill in this short survey and enter our monthly voucher draw 🎁',
    hero_delivery: 'How was your delivery?',
    hero_restaurant: 'How did you enjoy your visit?',
    progress: 'Progress',
    question_label: 'QUESTION',
    optional_badge: 'OPTIONAL',
    required_badge: 'REQUIRED',
    add_comment: '💬 Want to add a note? (optional)',
    comment_placeholder: 'Your comment for this question…',
    text_placeholder: 'Your answer…',
    text_placeholder_delivery: 'Tell us what we could improve… (optional)',
    photo_required: '📸 PHOTO · REQUIRED',
    photo_label: 'Add a photo of what you ordered!',
    photo_hint: 'e.g. cocktail of the month, glass of wine, dessert, dish. Without a photo you cannot enter the draw — selected photos will be posted on our Instagram.',
    choose_photo: 'Choose photo',
    contact_show_delivery: 'Leave contact details (optional)',
    contact_show_restaurant: 'Leave contact details (IMPORTANT — we will contact the winner directly)',
    contact_hide: 'Hide contact',
    contact_hint_delivery: 'We will call to thank you or fix an issue — contact is optional.',
    contact_hint_restaurant: 'If you win, we will contact you — without these details we cannot deliver the voucher.',
    name: 'Name',
    phone: 'Phone',
    email: 'E-mail',
    submit_delivery: '🎁 Send and claim your surprise',
    submit_restaurant: '🎁 Send and enter the draw',
    submitting: 'Sending…',
    answer_n_questions: (n) => `Answer ${n} more question${n === 1 ? '' : 's'}`,
    add_photo_to_join: '📸 Add a photo to enter',
    answer_and_add_photo: (n) => `Answer ${n} more question${n === 1 ? '' : 's'} and add a photo`,
    thanks: 'Thank you for your feedback!',
    your_code: 'Your code',
    copy_code: 'Copy code',
    copied: 'Copied!',
    order_with_discount: 'Order online with discount',
    loading: 'Preparing the survey…',
    ups: 'Oops…',
    footer_delivery: 'Your feedback goes straight to the MR JERRY manager',
    footer_restaurant: 'Your feedback goes straight to MR JERRY',
    no_coupon_msg: 'Unfortunately we have run out of coupons. Please call or message us — we will give you a reward in person.',
    voucher_default_title: 'Voucher for the winner',
    pool_size: (m, p) => `You are in the draw (month ${m}, pool: ${p})`,
    good_luck_restaurant: 'Good luck! We will contact the winner directly. Selected photos will be posted on',
  },
};

export const useT = (lang) => STR[lang] || STR.pl;
